module.exports = __webpack_public_path__ + "img/boton-atractivo.1b48626a.jpg";